import { Info } from '@mui/icons-material'
import { Tooltip as MuiTooltip, Typography } from '@mui/material'
import React from 'react'

const Tooltip = ({ infoText, textProps = {}, ...props }) => {
  return (
    <MuiTooltip
      sx={{ ml: 2 }}
      title={
        <Typography sx={{ fontSize: '18px', ...textProps.sx }}>
          {infoText}
        </Typography>
      }
      {...props}
    >
      <Info color='primary'></Info>
    </MuiTooltip>
  )
}

export default Tooltip
